export default __webpack_public_path__ + "static/media/People_Icon.6443e066.svg";